import React, { useEffect } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CarIcon from "@material-ui/icons/DirectionsCar";
import DriverLicenseIcon from "@material-ui/icons/AssignmentInd";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import getCountryFromURL from "src/utils/getCountryFromUrl";
import { replace } from "lodash";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { HERTZ_URL_LOGO } from "@packages/ui/constants";
import brandColors from "@packages/ui/theme/colors";

const useStyles = makeStyles({
  flexContainer: {
    display: "flex",
    textAlign: "center",
  },
  textStyles: {
    textAlign: "center",
  },
  breakLine: {
    // backgroundColor: "",
    borderColor: "#ffd100",
  },
  wordFormat: {
    // backgroundColor: "",
    textTransform: "none",
    textAlign: "center",
    fontSize: "small",
  },
});

const DigitalVIRExistingdamagePage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const athenaAuth = useSelector((state) => state.vir.athenaAuth);

  const athenaLogin = () => {
    const country = getCountryFromURL();
    const payload = {
      servicename: "shift",
      country: country == "AU" ? "au" : "nz",
      role: "customer",
    };
    dispatch(ATHENA_AUTH(payload));
  };

  useEffect(() => {
    console.log(athenaAuth);
    if (athenaAuth.data) {
      navigate("/vehicleincidents/login");
    }
  }, [athenaAuth]);

  return (
    <>
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <Box sx={{ mb: 4, textAlign: "left", margin: "0" }}>
          <img src={HERTZ_URL_LOGO} alt="Hertz Logo" width="100" />
        </Box>

        <h1>Damage Notice</h1>
        <br></br>
        <div className={classes.flexContainer}>
          <WarningIcon />
          <p>
            Damage has been identified on vehicle ABC-123 that was returned to Melbourne Airport on
            June 1st,2024.
          </p>
        </div>
        <br></br>
        <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] || brandColors.default }} />
        

        <Typography variant="body1" gutterBottom>
          The below damage has been identified:
        </Typography>

        <Typography variant="h6" gutterBottom>
          PASSENGER FRONT BUMPER
          <br />
          PASSENGER FRONT DOOR UPPER
        </Typography>

        {/* Instruction */}
        <Typography variant="body1" gutterBottom>
          Please complete the following vehicle incident report to provide us details of what
          happened. You will have the opportunity to share details of other involved drivers, as
          well as upload your own photos.
        </Typography>
        <Box sx={{ my: 3 }}>
          <Button
            className={classes.wordFormat}
            variant="contained"
            size="large"
            color="primary"
            sx={{ mb: 2, width: "80%", margin: "5" }}
          >
            View Damage Photos
          </Button>
        </Box>
        <Box sx={{ my: 3 }}>
          <Button
            className={classes.wordFormat}
            variant="contained"
            color="primary"
            size="large"
            sx={{ mt: 2, width: "80%", margin: "2" }}
          >
            Continue Form
          </Button>
        </Box>
        <Box textAlign="right">
          <Button
            className={classes.wordFormat}
            textAlign="right"
            color="primary"
            startIcon={<span className="material-icons"></span>}
            sx={{ textTransform: "lowercase", color: "primary", fontSize: "small" }}
          >
            <span>Report a new incident.</span>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DigitalVIRExistingdamagePage;
